import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f4cd3a2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "card border-primary border-top border-3 mb-5 mb-xl-10 col-md-3" }
const _hoisted_3 = { class: "card-header cursor-pointer p-0 d-flex justify-content-center" }
const _hoisted_4 = { class: "card-title m-0" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<p class=\"fs-6\" data-v-f4cd3a2a>Scan the QR using any UPI app on your phone.</p><div class=\"d-flex flex-row w-200px justify-content-between svelte-1d1h8ka\" data-v-f4cd3a2a><img class=\"d-flex h-30px\" src=\"https://cdn.razorpay.com/app/googlepay.svg\" alt=\"googlepay-app-logo\" data-v-f4cd3a2a><img class=\"d-flex h-30px\" src=\"https://cdn.razorpay.com/app/phonepe.svg\" alt=\"phonepe-app-logo\" data-v-f4cd3a2a><img class=\"d-flex h-30px\" src=\"https://cdn.razorpay.com/app/paytm.svg\" alt=\"paytm-app-logo\" data-v-f4cd3a2a><img class=\"d-flex h-30px\" src=\"https://cdn.razorpay.com/app/bhim.svg\" alt=\"bhim-app-logo\" data-v-f4cd3a2a></div>", 2)
const _hoisted_8 = { id: "kt_donate" }
const _hoisted_9 = { class: "card-body border-top pt-3" }
const _hoisted_10 = { class: "d-flex flex-wrap align-items-center mb-8" }
const _hoisted_11 = { class: "row mb-6" }
const _hoisted_12 = { class: "col-lg-12" }
const _hoisted_13 = { class: "fv-row mb-0" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "mobileNo",
  class: "form-label fs-6 fw-bold mb-3"
}, [
  /*#__PURE__*/_createTextVNode("Mobile Number (10 digit)"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "col-lg-12" }
const _hoisted_18 = { class: "fv-row mb-0" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label fs-6 fw-bold mb-3"
}, [
  /*#__PURE__*/_createTextVNode("Donor Name"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "col-lg-12" }
const _hoisted_23 = { class: "fv-row mb-0" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "form-label fs-6 fw-bold mb-3"
}, [
  /*#__PURE__*/_createTextVNode(" Email ID"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { class: "col-lg-12" }
const _hoisted_28 = { class: "fv-row mb-0" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "amount",
  class: "form-label fs-6 fw-bold mb-3"
}, " Amount (INR)", -1))
const _hoisted_30 = { class: "fv-plugins-message-container" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = {
  key: 0,
  class: "col-lg-12"
}
const _hoisted_33 = { class: "fv-row mb-0" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "amount",
  class: "form-label fs-6 fw-bold mb-3"
}, " Address", -1))
const _hoisted_35 = { class: "col-lg-12" }
const _hoisted_36 = { class: "fv-row mb-0 mt-2 form-check form-check-solid" }
const _hoisted_37 = ["checked", "value"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "whatsappReceipt"
}, [
  /*#__PURE__*/_createTextVNode("I want to receive the transaction receipt as "),
  /*#__PURE__*/_createElementVNode("span", { class: "badge bg-danger me-1 fs-6 fw-light" }, ".pdf"),
  /*#__PURE__*/_createTextVNode("document on WhatsApp.")
], -1))
const _hoisted_39 = {
  key: 0,
  class: "form-control d-flex justify-content-between bg-light-primary px-2"
}
const _hoisted_40 = { class: "form-check form-check-custom form-check-solid form-check-sm" }
const _hoisted_41 = ["checked"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "qrRadio"
}, "Generate QR", -1))
const _hoisted_43 = { class: "form-check form-check-custom form-check-solid form-check-sm" }
const _hoisted_44 = ["checked"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "onlineRadio"
}, "Multi Payment Option", -1))
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "row px-3 pb-2" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = { class: "indicator-label" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_51 = ["src"]
const _hoisted_52 = {
  key: 0,
  class: "d-flex flex-row justify-content-center align-items-center overlay-layer bg-primary bg-opacity-5 h-150px"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex flex-column spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_54 = [
  _hoisted_53
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (!_ctx.qrReady)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: "/media/illustrations/payment-vendor.jpg",
                alt: "payment-vendor_logo",
                class: _normalizeClass(["embed-responsive-item rounded", 'h-60px'])
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("h2", null, _toDisplayString(_ctx.timeLeft), 1),
                _createElementVNode("h3", null, [
                  _createTextVNode(" This QR Code will expire at "),
                  _createElementVNode("span", null, _toDisplayString(_ctx.endTime), 1)
                ])
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (!_ctx.qrReady)
              ? (_openBlock(), _createBlock(_component_Form, {
                  key: 0,
                  id: "kt_donation_form",
                  class: "form",
                  novalidate: "novalidate",
                  onSubmit: _cache[9] || (_cache[9] = ($event: any) => (
                _ctx.donorDetails.mode === 'QR' ? _ctx.retriveQRCode() : _ctx.makePayment()
              )),
                  "validation-schema": _ctx.paymentSchema
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _createVNode(_component_Field, {
                            type: "number",
                            class: "form-control form-control-lg form-control fw-semobold fs-5",
                            name: "mobileNo",
                            id: "mobileNo",
                            modelValue: _ctx.donorDetails.mobileNo,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.donorDetails.mobileNo) = $event)),
                            onChange: _ctx.getMembersByMobile1
                          }, null, 8, ["modelValue", "onChange"]),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createVNode(_component_ErrorMessage, { name: "mobileNo" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-lg form-control fw-semobold fs-5 text-uppercase",
                            name: "name",
                            id: "name",
                            modelValue: _ctx.donorDetails.name,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.donorDetails.name) = $event)),
                            onChange: _ctx.onInputChange
                          }, null, 8, ["modelValue", "onChange"]),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(_component_ErrorMessage, { name: "name" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _hoisted_24,
                          _createVNode(_component_Field, {
                            type: "email",
                            class: "form-control form-control-lg form-control fw-semobold fs-5",
                            name: "email",
                            id: "email",
                            modelValue: _ctx.donorDetails.email,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.donorDetails.email) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_ErrorMessage, { name: "email" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _hoisted_29,
                          _createVNode(_component_Field, {
                            type: "number",
                            class: "form-control form-control-lg form-control fw-bold fs-4",
                            name: "amount",
                            id: "amount",
                            modelValue: _ctx.donorDetails.amount,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.donorDetails.amount) = $event)),
                            readonly: _ctx.propsSettings.fixedAmount === 'true'
                          }, null, 8, ["modelValue", "readonly"]),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createVNode(_component_ErrorMessage, { name: "amount" })
                            ])
                          ])
                        ])
                      ]),
                      (_ctx.donorDetails.communications.whatsapp)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _hoisted_34,
                              _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    name: "address",
                                    id: "address",
                                    style: {"border-width":"thin !important"},
                                    modelValue: _ctx.donorDetails.communications.address,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.donorDetails.communications.address) = $event)),
                                    type: "textarea",
                                    rows: "3",
                                    placeholder: "Flat/Home Number, Street Name, Area Name, City Name, State, Zip Code"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            checked: _ctx.donorDetails.communications.whatsapp,
                            value: _ctx.donorDetails.communications.whatsapp,
                            id: "whatsappReceipt",
                            name: "whatsappReceipt",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (
                        _ctx.donorDetails.communications.whatsapp =
                          !_ctx.donorDetails.communications.whatsapp
                      ))
                          }, null, 8, _hoisted_37),
                          _hoisted_38
                        ])
                      ])
                    ]),
                    (_ctx.propsSettings.displayPaymentMode === 'true')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("input", {
                              class: "form-check-input",
                              type: "radio",
                              name: "flexRadioDefault",
                              id: "qrRadio",
                              onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.checkMode('QR'))),
                              checked: _ctx.donorDetails.mode === 'QR' ? 1 : 0
                            }, null, 40, _hoisted_41),
                            _hoisted_42
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("input", {
                              class: "form-check-input",
                              type: "radio",
                              name: "flexRadioDefault",
                              id: "onlineRadio",
                              onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.checkMode('UPI'))),
                              checked: _ctx.donorDetails.mode === 'UPI' ? 1 : 0
                            }, null, 40, _hoisted_44),
                            _hoisted_45
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_46, [
                      (_ctx.donorDetails.mode === 'Cash')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            style: {"margin-bottom":"0"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                class: "border border-primary border-active active",
                                style: {"border-width":"thin !important"},
                                modelValue: _ctx.donorDetails.remarks,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.donorDetails.remarks) = $event)),
                                type: "textarea",
                                rows: "3",
                                name: "remarks",
                                placeholder: "Remarks on Cash Handover, NEFT Transaction details etc.,"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("button", {
                        id: "kt_password_submit",
                        class: "btn btn-primary me-2 px-6",
                        ref: "paymentButton",
                        type: "submit",
                        disabled: _ctx.donorDetails.amount <= 0
                      }, [
                        _createElementVNode("span", _hoisted_49, " CONTINUE TO PAY " + _toDisplayString(_ctx.donorDetails.amount), 1),
                        _hoisted_50
                      ], 8, _hoisted_48)
                    ])
                  ]),
                  _: 1
                }, 8, ["validation-schema"]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["d-flex crop", _ctx.overlaySwitch])
                }, [
                  _createElementVNode("img", {
                    src: _ctx.qrReady,
                    alt: "qr",
                    onLoad: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onImgLoad && _ctx.onImgLoad(...args)))
                  }, null, 40, _hoisted_51),
                  (!_ctx.isLoaded)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, _hoisted_54))
                    : _createCommentVNode("", true)
                ], 2))
          ])
        ])
      ])
    ])
  ]))
}